(function ($, njm) {
    'use strict';

    njm.views.topcategories = Backbone.View.extend({
        events: {
            'click #linkcategories a': 'submitSearch'
            },
        initialize: function () {
        },
        submitSearch: function (e) {
            e.preventDefault();
            var element = $(e.currentTarget);
            var form = element.closest("form");
            form.find('input[id=searchInputRelated]').val(element[0].text);
            form[0].submit();
        }
    });
})(jQuery, njm);
